
import React from 'react';

import './styles.css';


class Spinner extends React.Component {

    render() {

        const className = this.props.overlay? 'spinner-holder overlay': 'spinner-holder';
        const text = this.props.message? this.props.message: 'Loading...';
        return (
            <div className={className}>
                <div className="inner">
                    <div className="spinner">
                        <div className="bounce1"></div>
                        <div className="bounce2"></div>
                        <div className="bounce3"></div>
                    </div>
                    <span className='text'>{text}</span>
                </div>
            </div>
        );
    }
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/spinner/Spinner.js